export const chatSliceName = 'TutorBotChat';
